export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8d3b1bdc3cb2b5799adfa58e3cd70d13.jpg"
          alt="Biblioteca Legal"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <div className="max-w-4xl">
          <h1 className="font-serif font-bold text-6xl lg:text-7xl xl:text-8xl text-white leading-tight mb-6 drop-shadow-lg">
            10 Años de Experiencia en el Poder Judicial
          </h1>
          <p className="text-xl lg:text-2xl text-gray-200 font-light mb-12 max-w-2xl">
            Ex-Fiscal | Especialista en Derecho Penal y Litigios Complejos
          </p>
          <button
            onClick={scrollToContact}
            className="group px-8 py-4 bg-gold text-black text-base font-semibold rounded-full hover:bg-gold-light transition-all duration-300 inline-flex items-center space-x-3 whitespace-nowrap cursor-pointer"
          >
            <span>Agendar Consulta</span>
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </div>
          </button>
        </div>

        {/* Credibility Badge */}
        <div className="absolute bottom-12 right-12 hidden lg:block">
          <p className="text-white text-xl font-light text-right">
            Más de 500 casos<br />exitosos resueltos
          </p>
        </div>
      </div>
    </section>
  );
}
